module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcarm0-c0d874685a7020532e400463769ff1da.jpg";